/* Site-wide constants. Swap these for CMS/API values later. */

export const SITE = {
  name: "Conectify Tech",
  tagline: "Data, Digital Marketing & Growth Solutions",
  description:
    "We power businesses with data-driven digital marketing, lead generation and intelligent solutions that connect you with the right audience and drive real growth.",
  email: "info@conectify-tech.com",
  phone: "+1 786 776 2152",
  address: "1000 Brickell Ave Ste Miami, FL 33131",
  year: new Date().getFullYear(),
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Solutions", href: "#solutions" },
  { label: "Industries", href: "#industries" },
  { label: "Resources", href: "#knowledge-hub" },
  { label: "Contact", href: "#contact" },
];

export const SOCIALS = [
  { label: "LinkedIn", icon: "linkedin", href: "https://linkedin.com" },
  {
    label: "Microsoft Teams",
    icon: "teams",
    href: "https://teams.microsoft.com/l/chat/0/0?users=conectify-tech@gmail.com",
  },
];
